import React, {Dispatch, SetStateAction, useRef, useEffect} from 'react';
import s from './CustomModal.module.css'
import {motion} from 'framer-motion';
import classNames from 'classnames';

type ModalType = {
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>
  isModalOpen: boolean,
  children: any,
  type?: 'confirm' | 'error' | 'contact',
  maxWidth?: string,
  maxHeight?: string,
  title?: string,
}

const CustomModal = ({setIsModalOpen, isModalOpen, children, type, maxWidth = '600px', maxHeight = '90vh', title}: ModalType) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (contentRef.current && !contentRef.current.contains(e.target as Node)) {
      setIsModalOpen?.(false);
    }
  };

  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isModalOpen) {
        setIsModalOpen?.(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen, setIsModalOpen]);

  return (
    <>
      {isModalOpen
        ? <motion.div 
            className={s.wrapper} 
            ref={modalRef}
            onClick={handleBackdropClick}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.3}}
          >
          <div 
            ref={contentRef}
            className={classNames(s.content_wrapper, {
              [s.confirmModal]: type === 'confirm',
              [s.error]: type === 'error',
              [s.contact]: type === 'contact',
              [s.has_title]: !!title
            })}
            style={{ 
              maxWidth,
              maxHeight
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {title && (
              <div className={s.modal_title}>
                {title}
              </div>
            )}
            <div className={classNames(s.scrollable_content, {
              [s.short_content]: type === 'contact',
              [s.content]: type !== 'contact'
            })}>
              {children}
            </div>
          </div>
        </motion.div>
        : <></>
      }
    </>
  );
};

export default CustomModal;
